(function() {
    'use strict';

    angular
        .module('dentist')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];

    function stateConfig($stateProvider, $urlRouterProvider, $locationProvider) {
        
       $stateProvider
       .state('businesscards', {
           url: "/{region}/suche?treatment&highlight&scroll",
           params: {
               landingTexts: null,
               scroll: null
           },
           templateUrl: "templates/businesscards.html",
           controller: 'businesscardsController',
           controllerAs: 'ctrl'
       });
       
       window.businesscardsLandingPages.forEach(function(landing) {
           if (landing.isDedicatedLandingPage) {
               return;
           }

           $urlRouterProvider.when(landing.path, function ($match, $state) {
               $state.go('businesscards', {region: $match.region, treatment: landing.treatment, landingTexts: landing, scroll: null}, {location: false});
           });
       });

       //$urlRouterProvider.otherwise("/suche");
       
       $locationProvider.html5Mode({enabled: true, rewriteLinks: false});

    }

})();
